import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const routeFor = (u) => (u.must_change_password ? "/trocar-senha" : u.role === "admin" ? "/painel" : "/conta");

  useEffect(() => { if (user) navigate(routeFor(user), { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bem-vindo de volta.");
      navigate(routeFor(u), { replace: true });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-ink border border-white/15 px-4 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-cobalt transition-colors duration-300";

  return (
    <div className="min-h-screen grain flex items-center justify-center px-6">
      <Link to="/" className="absolute top-6 left-6 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-white/50 hover:text-white transition-colors" data-testid="login-back">
        <ArrowLeft className="w-4 h-4" /> Voltar
      </Link>
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
        <img src="/logo-full.png" alt="JeaxLabs" className="h-9 w-auto mb-8" />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">Área do Cliente</span>
        <h1 className="font-head font-black text-4xl tracking-tight mt-3 mb-8">Acesse a sua conta</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <input data-testid="login-email" type="email" className={field} placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" className={field} placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button type="submit" disabled={loading} data-testid="login-submit"
                  className="w-full inline-flex items-center justify-center gap-3 bg-cobalt text-white px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-white hover:text-ink transition-colors duration-300 disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
